import React from 'react';

import Heading from 'Components/Heading/Heading';
import TeamSJ from '../../Assets/elvotaimages/team_SJ.jpeg';

import TeamCard from './TeamCard';

export default function Team() {
  const contentValues = [
    {
      name: 'Stanislas Jouven',
      position: 'Founder, CEO',
      addtionalText: [
        'Stanislas has deep roots in the renewable energy industry, leveraging over 20 years of family experience in solar, wind, and battery storage development across global markets. He founded Evolta Technologies with the conviction that intelligent energy trading is key to accelerating the adoption of clean technologies.',
        'He worked as a data scientist at Firmenich, where he developed machine learning models to predict sensory and emotional responses to novel chemical formulas. He brings this quantitative rigor to the energy markets, combining algorithmic trading with a hands on understanding of asset operations.',
        "Stanislas holds a Master's degree in Data Science from EPFL in Lausanne, Switzerland.",
      ],
      imageSrc: TeamSJ,
      linkedinLink: 'https://www.linkedin.com/in/stanislas-jouven/',
    },
  ];
  return (
    <div>
      <Heading content="Team" />
      <div className="grid grid-cols-12">
        {contentValues.map(
          (
            value,
            index // Use map to render elements
          ) => (
            <>
              {index === 1 && <div className="col-span-1" />}
              <div
                className="col-span-12 sm:col-span-5 xs:col-span-12 mb-4"
                key={value.imageSrc || index}
              >
                <TeamCard
                  name={value.name}
                  position={value.position}
                  additionalText={value.addtionalText}
                  imageSrc={value.imageSrc}
                  linkedinLink={value.linkedinLink}
                />
              </div>{' '}
            </>
          )
        )}
      </div>
    </div>
  );
}
